import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

import AppIcon from '../../../components/AppIcon';
import helpers from '../../../utils/helpers';
import axios from '../../../configs/axios';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { format } from '../../../utils/date';

class AppsList extends Component {
  static propTypes = {
    apps: PropTypes.array,
    hubspotContactPresent: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      validEmail: true,
      showError: false,
      errorMessage: 'Please input valid email',
      hubspotContactPresent: this.props.hubspotContactPresent,
      successMessage: '',
      email: '',
      pending: false,
    };
  }
  handleClick = (e) => {
    e.preventDefault();
    const { validEmail, email } = this.state;
    if (!validEmail || email.length < 1) {
      this.setState({ showError: true });
    }
    if (validEmail && email.length > 0) {
      this.setState(
        {
          showError: false,
          errorMessage: 'Please input valid email',
          pending: true,
        },
        () => {
          axios
            .post('/hubspot_submits/marketing_contact', { contact: { email } })
            .then(({ data }) => {
              setTimeout(() => {
                this.setState({
                  successMessage: data.success_message,
                  pending: false,
                });
              }, 1000);
            })
            .then(() => {
              setTimeout(() => {
                this.setState({
                  successMessage: '',
                  hubspotContactPresent: true,
                });
              }, 2700);
            })
            .catch(
              ({
                response: {
                  data: { message },
                },
              }) => {
                this.setState({
                  showError: true,
                  errorMessage: message,
                  pending: false,
                });
              }
            );
        }
      );
    }
  };
  handleChange = (e) => {
    const {
      target: { value },
    } = e;
    if (value.length > 0) {
      this.setState({
        showError: false,
        validEmail: helpers.validateEmail(value),
        email: value,
      });
    }
  };
  renderList = (apps) =>
    apps.map((app) => {
      const formatedDate = format(app.sdk_installed_date, 'MMM DD, YYYY');
      return (
        <div
          key={`${app.id}-${app.sdk_id}`}
          className="d-flex flex-row justify-content-between sdk-search-application"
        >
          <LoadingOverlay loading={this.state.pending} />
          <div key={`${app.id}-${app.sdk_id}`} className="mb-xs d-flex flex-row">
            <div className="mr-xs">
              <AppIcon
                url={app.icon_url_2x}
                store={app.store}
                size={38}
                alt={app.app_name}
                containerClasses="mr-xs img-rounded"
              />
            </div>
            <div className="d-flex flex-column justify-content-between">
              <p className="text-16 text-black text-truncate" style={{ maxWidth: 250 }}>
                {app.app_name}
              </p>
              <p className="text-12 text-quiet text-truncate" style={{ maxWidth: 250 }}>
                {app.publisher_name}
              </p>
            </div>
          </div>
          <div className="d-flex flex-column">
            <p className="text-12 text-quiet">{formatedDate}</p>
          </div>
        </div>
      );
    });
  render() {
    const { apps } = this.props;
    const { showError, successMessage, hubspotContactPresent, errorMessage } = this.state;
    return (
      <Fragment>
        {hubspotContactPresent && apps && this.renderList(apps)}
        {!hubspotContactPresent && apps && (
          <Fragment>
            {this.renderList([apps[0]])}
            <div className="d-flex flex-column align-items-center hover-box">
              {!successMessage && (
                <form className="email-form">
                  <input
                    type="text"
                    className="email form-control"
                    placeholder="Enter your business email for more results"
                    onChange={this.handleChange}
                  />
                  <input type="submit" className="btn-submit" onClick={this.handleClick} />
                </form>
              )}
              {showError && <p className="text-red pt-xs">{errorMessage}</p>}
              {successMessage && <p className="text-green text-md pt-xs">{successMessage}</p>}
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default AppsList;
